module.exports = __webpack_public_path__ + "static/media/friends-of-tmc-icon-dark.aab53d92.svg";